import { render, staticRenderFns } from "./InboxComponent.vue?vue&type=template&id=ba151936&scoped=true&"
import script from "./InboxComponent.vue?vue&type=script&lang=js&"
export * from "./InboxComponent.vue?vue&type=script&lang=js&"
import style0 from "./InboxComponent.vue?vue&type=style&index=0&id=ba151936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba151936",
  null
  
)

export default component.exports